module.exports = __webpack_public_path__ + "c747a4a44bd28bc43b87d1d7ea4b6a0b.pdf";